import { Injectable } from '@angular/core';

@Injectable()
export class EmailTransactionDomain {
    constructor() { }

    destroy(): void {

    }
}



// WEBPACK FOOTER //
// ./src/app/components/email-transaction/domain/email-transaction.domain.ts